import React, { Component } from "react";
import { connect } from "react-redux";
import {
  getAnnouncementDetails,
  selectAnnouncementDetail
} from "../../../state/ducks/dashboard/index";

class AnnouncementDetail extends Component {
  componentDidMount() {
    const { match } = this.props;
    this.props.getAnnouncementDetails(match?.params?.id);
  }
  render() {
    const { detail } = this.props;
    return (

      <div className="container-fluid">
        {/* yesil Alan*/}
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            {/* KUTU 1 */}
            <div className="row no-gutters t-kutu t-yesilCizgi">
              <div
                className="col bosluk backright"
                style={{
                  backgroundImage: 'url("/assets/img/backgrounds/back_right_yesil.jpg")'
                }}
              >
                {/* içerikler */}
                {/* Başlık */}
                <div className="row no-gutters pb-4">
                  <div className="col-auto">
                    <i className="t-icon-tv icon" />
                  </div>
                  <div className="col d-flex flex-column justify-content-center">
                    <div className="baslik" style={{ padding: "0 0 5px 0" }}>
                    {detail?.konu}
                    </div>
                    <span className="altBaslik"> </span>
                  </div>
                </div>
                <div className="row" dangerouslySetInnerHTML={{ __html: detail.htmlIcerik }}>
                 
                </div>
                {/* içerikler BİTTİ */}
              </div>
              <div className="col-auto renk" />
            </div>
            {/* KUTU 1 BİTTİ */}
          </div>
        </div>
        {/* Duyurlar Baslık*/}
        {/* duyrular Bitti*/}
        <div className="row" style={{ height: 30 }} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    detail: selectAnnouncementDetail(state)
  };
};

const mapDispatchToProps = dispatch => ({
  getAnnouncementDetails: announcementId =>
    dispatch(getAnnouncementDetails(announcementId))
});

export default connect(mapStateToProps, mapDispatchToProps)(AnnouncementDetail);
